import React from 'react';

import FallbackLoader from './FallbackLoader';

// import Modal from 'shared-components/components/Modal';

export default FallbackLoader(() => import(/* webpackChunkName: "async-Modal" */'shared-components/components/Modal'), { fallback: <div style={{ display: 'none' }} /> });
